import React from "react";
import { BsCardList } from "react-icons/bs";

/**
 * ResultsReadyModal Component
 * 
 * Success notification modal indicating that search/filter results are ready for viewing.
 * Provides a clickable "View" link that scrolls the page to results.
 * 
 * @param {string} ElementId - DOM element ID to scroll to when "View" is clicked
 * @returns {JSX.Element} Success notification with view results link
 */
const ResultsReadyModal = (ElementId) => {
  // Scroll to results when user clicks "View" link
  function scrollToTop() {
    window.scrollTo(0, 0);
    document.getElementById(ElementId).scrollIntoView();
  }

  return (
    <div style={{ paddingTop: "10px" }}>
      <p style={{ color: "#1f5f8b" }}>
        <BsCardList className="alert-icon" /> Results
      </p>
      <p style={{ marginLeft: "28px" }}>
        Your results are ready.{" "}
        <a href="#" className="alert-cta" onClick={scrollToTop}>
          View
        </a>
      </p>
    </div>
  );
};

export default ResultsReadyModal;
